
<div class="chart-container">
    <div *ngIf="isLoading && !noLoading" class="loading">
        <img src="assets/img/oval.svg" class="loading-icon" />
      </div>
      <ng-container>
        <echarts (chartInit)="onChartInit($event)" [options]="chartConfig" ></echarts>
            </ng-container>
            
</div>